import { AcodisWorkflowService } from 'src/app/domain/import-configuration/acodis-workflow/acodis-workflow.service';

import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { DropDownListModule } from '@syncfusion/ej2-angular-dropdowns';
import { AppErrorMessagesComponent } from 'src/app/base/error-messages/app-error-messages.component';
import { AcodisWorkflowDTO, AcodisWorkflowTestResult, ImportType } from 'src/app/base/models/models.swagger.generated';
import { EnumTranslationService } from 'src/app/base/services/enum-translation.service';
import { DropDownConstantsFactory } from 'src/app/base/shared/syncfusion/dropdown-constants-factory';
import { AcodisWorkflowFormType } from './acodis-workflow-form-type';
import { map, Observable, of, raceWith } from 'rxjs';
import { ModalService } from 'src/app/base/shared/modal/modal.service';

@Component({
    selector: 'app-acodis-workflow-form',
    templateUrl: './acodis-workflow-form.component.html',
    styleUrls: ['./acodis-workflow-form.component.scss'],
    imports: [ReactiveFormsModule, AppErrorMessagesComponent, TranslateModule, DropDownListModule]
})
export class AcodisWorkflowFormComponent {

  public testResult: AcodisWorkflowTestResult;
  public isTestingConnection = false;

  constructor(
    private enumTranslateService: EnumTranslationService,
    private acodisWorkflowService: AcodisWorkflowService,
    private modalService: ModalService
  ) { }

  @Input()
  public acodisWorkflowForm: FormGroup<AcodisWorkflowFormType>;

  public importTypes = this.enumTranslateService.translateNumericEnum(ImportType, 'i18n.domain.import-configuration.enums.import-type.');
  public enumDropdownSettings = DropDownConstantsFactory.createNumericEnumDropdownSettings();

  public testAcodisWorkflow() {
    this.acodisWorkflowForm.markAllAsTouched();
    if (this.acodisWorkflowForm.valid) {
      var dto = new AcodisWorkflowDTO({
        name: this.acodisWorkflowForm.controls.name.value,
        userName: this.acodisWorkflowForm.controls.userName.value,
        password: this.acodisWorkflowForm.controls.password.value,
        importType: this.acodisWorkflowForm.controls.importType.value
      });
      this.isTestingConnection = true;
      this.acodisWorkflowService.testAccodisWorkflow(dto).subscribe(res => {
        this.testResult = res;
      }).add(() => {
        this.isTestingConnection = false
      });
    }
  }

  public canCloseForm(): Observable<boolean> {
    if (this.acodisWorkflowForm.dirty) {
      const dialog = this.modalService.showOkCancelDialog('i18n.domain.import-configuration.acodis-workflows.discard-dialog.title', 'i18n.domain.import-configuration.acodis-workflows.discard-dialog.question');
      const okObservable = dialog.onOkSubject.pipe(map(() => {
        return true;
      }));
      const cancelObservable = dialog.onCancelSubject.pipe(map(() => false));
      return okObservable.pipe(raceWith(cancelObservable));
    } else {
      return of(true);
    }
  }

  public reset() {
    this.acodisWorkflowForm.reset();
    this.testResult = null;
  }
}
